import { log } from '@atlassian/mpac-utils';
import { getInstallMode } from '../../../actions/Installation/InstallMode/DeterminingInstallMode';
export const getAppInstallMode = async _ref => {
  let {
    mpacBaseUrl,
    appIdentifier,
    hostInfo,
    flags,
    hostCmtEnabled
  } = _ref;
  try {
    const installMode = await getInstallMode({
      mpacBaseUrl,
      installableAppId: appIdentifier,
      context: hostInfo.globalContext,
      flags,
      hostCmtEnabled
    });
    const appInstallMode = installMode.fold(error => {
      console.error("Either the SPI's getInstallableAddon returned an error or invalid shape, " + 'or MPAC returned an invalid instructional listing: ', error);
    }, im => im);
    return appInstallMode;
  } catch (error) {
    log.error('AppInstallDialog/getAppInstallMode', 'Failed with', {
      error
    });
  }
};